import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PracticeAreas from './components/PracticeAreas';
import HowWeWork from './components/HowWeWork';
import Differentials from './components/Differentials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="font-sans">
      <Navbar />
      <Hero />
      <About />
      <PracticeAreas />
      <HowWeWork />
      <Differentials />
      <Contact />
      <Footer />
    </main>
  );
}
